"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERROR_DETAILS = void 0;
exports.ERROR_DETAILS = {
    UnsupportedNetwork: "Network is not supported",
    WalletNotInitiated: "Wallet is not initiated",
};
